/* global Swiper,attachEvent */
// **********************************************************
// Gallery Modal Slider
// **********************************************************

const galleryModalSliderSwiperElements = document.querySelectorAll('[data-slider="gallery-modal__slider"]');
const galleryModalSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    prevEl: '.swiper-button-next',
    nextEl: 'swiper-button-prev',
  },
};

galleryModalSliderSwiperElements.forEach((el) => {
  const galleryModalSliderParent = el.closest('.gallery-modal');
  const arrowRight = galleryModalSliderParent.querySelector('.arrow-right');
  const arrowLeft = galleryModalSliderParent.querySelector('.arrow-left');

  galleryModalSliderOptions.navigation.nextEl = arrowRight;
  galleryModalSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-unused-vars
  const galleryModalSlider = new Swiper(el, galleryModalSliderOptions);

  attachEvent('.gallery-block', 'click', (ev) => {
    const targetSlide = ev.target.getAttribute('data-gallery');
    galleryModalSlider.slideTo(targetSlide - 1, 0);
  });
});

// *******************************************************************************
// Close Gallery-modal
// *******************************************************************************

attachEvent('.gallery-modal__close', 'click', (ev) => {
  const parentEle = ev.target.closest('.gallery-modal');
  parentEle.classList.remove('is-open-gallery-modal');
});
